import React, {useEffect, useRef, useState} from "react";
import Icon from "sulu-admin-bundle/components/Icon";
import Submit from "./HandleSubmit"
import {
  changeSecondsToMinsAndSeconds,
  changeSecondsToString,
} from "../../hooks/useCountdown";


const ChangeQuarterAndTime = ({ eventDetails, setEventDetails, matchId, matchData, setMatchData, setEventsToShow, setConfirmButton }) => {
  const originalTimestamp = useRef(eventDetails?.timestamp);
  const [minutes, setMinutes] = useState(
    changeSecondsToMinsAndSeconds(eventDetails?.timestamp)?.mins
  );
  const [seconds, setSeconds] = useState(
    changeSecondsToMinsAndSeconds(eventDetails?.timestamp)?.secs
  );
  const isFirstRun = useRef(true);
  useEffect(() => {
      if(!isFirstRun.current) {
          const mins = Number(Math.floor(minutes * 60));
          const secs = Number(seconds);
          const timestamp = mins + secs;
          setConfirmButton(true);
          setEventDetails((data) => ({
              ...data,
              timestamp,
          }));
      }
      isFirstRun.current = false;
  }, [minutes, seconds]);

  changeSecondsToString("timeOfEvent", eventDetails?.timestamp);
  changeSecondsToMinsAndSeconds(eventDetails?.timestamp)?.mins;
  changeSecondsToMinsAndSeconds(eventDetails?.timestamp)?.secs;

  const periods = [...Array(eventDetails.numberOfPeriods).keys()];

  const handleNumChange = params => {
        const {event, second, minute} = params;
        const limit = 2;
        if(minute) {
            setMinutes(event.target.value.slice(0, limit));
        }
        if(second) {
            setSeconds(event.target.value.slice(0, limit));
        }
  };

  return (
    <div
      style={{
        padding: "10px 30px",
        display: "flex",
        alignItems: "center",
      }}
    >
      <div
        style={{
          borderRadius: "50%",
          backgroundColor: "transparent",
          border: "1px solid black",
          height: 35,
          width: 35,
          fontWeight: 700,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginRight: 20,
        }}
      >
        <Icon name="su-clock" />
      </div>

      <div
        style={{
          width: "85%",
        }}
      >
        <div
          style={{
            display: "flex",
          }}
        >
          {periods.map((quarter, index) => {
            let period = eventDetails.periodAbbreviation ? eventDetails.periodAbbreviation + (index + 1) : eventDetails.quarterSelected;
            const quarterNumber = +eventDetails?.quarterSelected.slice(-1);
            return (
              <button
                key={index}
                style={{
                  borderRadius: 5,
                  backgroundColor: "white",
                  cursor: "pointer",
                  color:
                    quarterNumber === index + 1
                      ? "black"
                      : "lightgray",
                  border: `2px solid ${
                    quarterNumber === index + 1
                      ? "black"
                      : "lightgray"
                  }`,
                  height: 40,
                  width: 40,
                  fontWeight: 700,
                  marginRight: 10,
                }}
                onClick={() => {
                  setEventDetails((data) => ({
                    ...data,
                    quarterSelected: period,
                  }));
                }}
              >
                {period}
              </button>
            );
          })}

          <div
            style={{
              marginLeft: 20,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <input
              style={{
                borderRadius: 5,
                backgroundColor: "black",
                color: "white",
                border: `none`,
                height: 40,
                width: 40,
                fontWeight: 700,
                marginRight: 10,
                textAlign: "center",
              }}
              value={minutes}
              onChange={(e) => {
                setMinutes(e?.target?.value);
                handleNumChange({event: e, second: false, minute: true});
              }}
              type='number'
              onKeyPress={(e) => {
                  if (e.key === "e" || e.key === "-") {
                      e.preventDefault();
                  }
              }}
            />

            <input
              style={{
                borderRadius: 5,
                backgroundColor: "black",
                color: "white",
                border: `none`,
                height: 40,
                width: 40,
                fontWeight: 700,
                marginRight: 10,
                textAlign: "center",
              }}
              value={seconds}
              onChange={(e) => {
                setSeconds(e?.target?.value);
                handleNumChange({event: e, second: true, minute: false});
              }}
              type='number'
              onKeyPress={(e) => {
                  if (e.key === "e" || e.key === "-") {
                      e.preventDefault();
                  }
              }}
            />

            <p
              style={{
                fontWeight: 700,
              }}
            >
              min
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangeQuarterAndTime;
